import styled from 'styled-components'

export const DeleteLink = styled.a`
  color: ${props => props.theme['@text-color']};
  margin-right: ${props => props.theme['@size-xs']};
`
